import { askGemini } from '../components/AiModal.js'
import { clinicsFetch } from '../functions/fetchClinics.js'

const triggerAi = async (query, s) => {
  const thread = [
    ...(s.root.aiModalThread || []),
    { role: 'user', content: query }
  ]
  s.root.update({
    showAiModal: true,
    aiModalThread: thread,
    aiModalLoading: true
  })
  try {
    const reply = await askGemini(thread, s.root.clinics || [])
    s.root.update({
      aiModalThread: [...thread, { role: 'assistant', content: reply }],
      aiModalLoading: false
    })
  } catch (err) {
    s.root.update({
      aiModalThread: [
        ...thread,
        { role: 'assistant', content: 'Error: ' + err.message }
      ],
      aiModalLoading: false
    })
  }
}

export const landing = {
  extends: 'Page',
  flow: 'y',
  background: '#FFFFFF',
  color: 'inkText',

  ClinicsData: { fetch: clinicsFetch, display: 'none' },

  AiModal: {},

  NavBar: {
    background: 'transparent',
    backdropFilter: 'none',
    borderBottom: 'none',
    position: 'absolute',
    top: '0',
    zIndex: '10',
    LogoLink: { color: '#0D1117' },
    NavLinks: {
      FeaturesLink: { color: '#0D1117' },
      PricingLink: { color: '#0D1117' },
      ClinicsLink: { color: '#0D1117' },
      AiLink: { color: '#0D1117' },
      ForBusinessLink: { color: '#0D1117' }
    },
    NavRight: {
      DashLink: { color: '#0D1117' }
    }
  },

  HeroSection: {
    tag: 'section',
    position: 'relative',
    overflow: 'hidden',
    flow: 'y',
    align: 'center center',
    textAlign: 'center',
    width: '100%',
    minHeight: '90dvh',
    background:
      '#F5F6FA url(https://i.ibb.co/ym9m7N2s/unnamed.jpg) center / cover no-repeat',
    '@mobileL': { minHeight: '80dvh' },

    HeroContent: {
      position: 'relative',
      zIndex: '1',
      flow: 'y',
      align: 'center center',
      gap: 'A',
      padding: '0 B F B',
      maxWidth: 'K',
      width: '100%',
      '@mobileL': { padding: '0 A D A', gap: 'Z' },

      HeroTagline: {
        tag: 'span',
        text: '{{ heroTagline | polyglot }}',
        fontSize: 'Z',
        fontWeight: '600',
        color: 'inkMuted',
        textTransform: 'uppercase',
        letterSpacing: 'Y',
        background: 'white',
        padding: 'Y A',
        round: 'D',
        border: 'none'
      },
      HeroTitle: {
        tag: 'h1',
        text: '{{ heroTitle | polyglot }}',
        fontSize: 'H',
        fontWeight: '800',
        letterSpacing: '-0.05em',
        lineHeight: '1.0',
        color: 'inkText',
        '@mobileL': { fontSize: 'E' }
      },
      HeroSubtitle: {
        tag: 'h2',
        text: '{{ heroSubtitle | polyglot }}',
        fontSize: 'B',
        fontWeight: '400',
        color: 'inkText',
        maxWidth: 'I',
        lineHeight: '1.5',
        '@mobileL': { fontSize: 'A' }
      }
    },

    HeroPrompt: {
      position: 'absolute',
      bottom: 'C',
      left: '50%',
      attr: { style: 'transform: translateX(-50%)' },
      flow: 'y',
      align: 'center center',
      gap: 'A',
      width: '100%',
      maxWidth: 'I',
      zIndex: '2',
      padding: '0 B',
      '@mobileL': { bottom: 'B', padding: '0 A' },

      PromptInput: {
        flow: 'x',
        align: 'flex-end center',
        gap: 'Z',
        width: '100%',
        background: 'rgba(255,255,255,0.75)',
        backdropFilter: 'blur(16px)',
        border: '1px solid rgba(0,0,0,0.1)',
        round: 'B',
        padding: 'A',
        boxShadow: '0 4px 24px rgba(0,0,0,0.08)',
        transition: 'all 0.3s ease',
        ':hover': {
          boxShadow: '0 8px 32px rgba(0,0,0,0.12)',
          border: '1px solid rgba(0,0,0,0.15)'
        },

        SearchInput: {
          tag: 'textarea',
          placeholder: '{{ searchPlaceholder | polyglot }}',
          flex: '1',
          padding: 'Y 0',
          background: 'transparent',
          border: 'none',
          fontSize: 'A',
          fontFamily: 'inherit',
          color: '#1D1D1F',
          outline: 'none',
          resize: 'none',
          height: 'D',
          lineHeight: '1.5',
          attr: { rows: '3' },
          on: {
            keydown: (e, el, s) => {
              if (e.key === 'Enter' && !e.shiftKey) {
                e.preventDefault()
                const query = el.node.value
                if (!query.trim()) return
                el.node.value = ''
                triggerAi(query, s)
              }
            }
          }
        },
        SearchBtn: {
          tag: 'button',
          background: '#0D1117',
          color: '#FFFFFF',
          fontWeight: '600',
          width: 'B1',
          height: 'B1',
          round: 'B',
          cursor: 'pointer',
          border: 'none',
          transition: 'all 0.2s ease',
          ':hover': { opacity: '0.9' },
          align: 'center center',
          flexShrink: '0',
          ArrowIcon: {
            extends: 'Icon',
            icon: 'arrowUp',
            width: 'A',
            height: 'A',
            color: '#FFFFFF'
          },
          onClick: (e, el, s) => {
            const input = el.lookup('SearchInput')
            const query = input.node.value
            if (!query.trim()) return
            input.node.value = ''
            triggerAi(query, s)
          }
        }
      },

      PromptChips: {
        flow: 'x',
        gap: 'Y',
        flexWrap: 'wrap',
        align: 'center center',
        children: [
          { label: '{{ chipImplant | polyglot }}' },
          { label: '{{ chipWhitening | polyglot }}' },
          { label: '{{ chipEmergency | polyglot }}' },
          { label: '{{ chipOrtho | polyglot }}' }
        ],
        childrenAs: 'state',
        childExtends: {
          tag: 'button',
          text: (el, s) => s.label,
          background: 'rgba(255,255,255,0.5)',
          backdropFilter: 'blur(8px)',
          border: '1px solid rgba(0,0,0,0.08)',
          padding: 'Y Z',
          round: 'C',
          fontSize: 'Z',
          color: '#555',
          fontWeight: '500',
          cursor: 'pointer',
          transition: 'all 0.2s ease',
          ':hover': { background: 'rgba(255,255,255,0.8)', color: '#1D1D1F' },
          onClick: (e, el, s) => triggerAi(s.label, s)
        }
      }
    }
  },

  ScrollHint: {
    flow: 'y',
    align: 'center center',
    gap: 'Y',
    padding: 'B 0',
    opacity: '0.3',
    ScrollText: {
      text: '{{ scrollExplore | polyglot }}',
      fontSize: 'Y',
      color: '#1D1D1F',
      textTransform: 'uppercase',
      letterSpacing: '0.15em',
      fontWeight: '500'
    },
    ScrollArrow: {
      extends: 'Icon',
      icon: 'chevronDown',
      width: 'Z',
      height: 'Z',
      color: '#1D1D1F'
    }
  },

  PopularClinics: {
    tag: 'section',
    flow: 'y',
    gap: 'B',
    padding: 'D B',
    width: '100%',
    maxWidth: 'K',
    margin: '0 auto',
    '@mobileL': { padding: 'C A' },
    PopularSubtitle: {
      text: '{{ topRated | polyglot }}',
      fontSize: 'B',
      fontWeight: '400',
      color: 'inkMuted',
      textAlign: 'left',
      marginBottom: 'A',
      lineHeight: '1.5'
    },
    ClinicsLayout: {
      flow: 'x',
      gap: 'A',
      width: '100%',
      align: 'stretch flex-start',
      '@mobileL': { flow: 'y' },

      ClinicsList: {
        flex: '1',
        flow: 'y',
        gap: 'A',
        minWidth: '0',
        position: 'relative',
        ClinicGrid: {
          display: 'grid',
          gridTemplateColumns: 'repeat(2, 1fr)',
          gap: 'A',
          '@mobileL': { gridTemplateColumns: '1fr' },
          children: (el, s) => (s.root.clinics || []).slice(0, 6),
          childrenAs: 'state',
          childExtends: 'ClinicListCard'
        },
        GradientOverlay: {
          position: 'absolute',
          bottom: '0',
          left: '0',
          width: '100%',
          height: 'F',
          background:
            'linear-gradient(to bottom, transparent 0%, rgba(255,255,255,0.5) 25%, #FFFFFF 75%)',
          zIndex: '1'
        },
        ViewAllBtn: {
          extends: 'Link',
          href: '/clinics',
          text: '{{ viewAllClinics | polyglot }}',
          position: 'absolute',
          bottom: 'Y',
          left: 'A',
          zIndex: '2',
          background: '#0D1117',
          color: '#FFFFFF',
          fontWeight: '600',
          padding: 'Z B',
          round: 'C',
          fontSize: 'Z',
          textDecoration: 'none',
          cursor: 'pointer',
          boxShadow: '0 4px 24px rgba(255,255,255,0.8)',
          transition: 'all 0.2s ease',
          ':hover': { boxShadow: '0 8px 32px rgba(255,255,255,0.9)' }
        }
      },

      MapPanel: {
        width: '420px',
        flexShrink: '0',
        flow: 'y',
        gap: 'Z',
        '@mobileL': { width: '100%' },

        MapContainer: {
          width: '100%',
          flex: '1',
          minHeight: '400px',
          round: 'A',
          border: 'none',
          overflow: 'hidden',
          attr: { id: 'clinic-map' },
          onRender: (el, s) => {
            if (el.node._mapInit) return
            el.node._mapInit = true

            const initMap = () => {
              const mapStyles = [
                { featureType: 'poi', stylers: [{ visibility: 'off' }] },
                { featureType: 'transit', stylers: [{ visibility: 'off' }] },
                {
                  featureType: 'road',
                  elementType: 'labels',
                  stylers: [{ visibility: 'simplified' }]
                },
                {
                  featureType: 'water',
                  elementType: 'geometry',
                  stylers: [{ color: '#e3e8ee' }]
                },
                { featureType: 'landscape', stylers: [{ color: '#f5f5f5' }] },
                {
                  featureType: 'road',
                  elementType: 'geometry',
                  stylers: [{ color: '#ffffff' }]
                },
                {
                  featureType: 'road.arterial',
                  elementType: 'geometry',
                  stylers: [{ color: '#e8e8e8' }]
                }
              ]

              const map = new google.maps.Map(el.node, {
                center: { lat: 41.715, lng: 44.78 },
                zoom: 13,
                styles: mapStyles,
                disableDefaultUI: true,
                zoomControl: true,
                zoomControlOptions: {
                  position: google.maps.ControlPosition.RIGHT_TOP
                }
              })

              const clinics = s.root.clinics || []
              clinics.forEach((c) => {
                if (!c.lat || !c.lng) return
                const marker = new google.maps.Marker({
                  position: { lat: c.lat, lng: c.lng },
                  map,
                  title: c.name,
                  icon: {
                    path: 'M12 2C9.5 2 7 3.5 6 5.5c-1.5 3-.5 5 0 7.5.5 2.5-.5 5.5 1 8 .5.8 1.5 1 2 1s1-.5 1.5-2c.5-1.5 1-2 1.5-2s1 .5 1.5 2c.5 1.5 1 2 1.5 2s1.5-.2 2-1c1.5-2.5.5-5.5 1-8 .5-2.5 1.5-4.5 0-7.5C17 3.5 14.5 2 12 2z',
                    fillColor: '#0D1117',
                    fillOpacity: 1,
                    strokeColor: '#FFFFFF',
                    strokeWeight: 2,
                    scale: 1.2,
                    anchor: new google.maps.Point(12, 22)
                  }
                })
                const info = new google.maps.InfoWindow({
                  content:
                    '<div style="font-family:system-ui;padding:4px"><b>' +
                    c.name +
                    '</b><br><span style="color:#00C9A7">' +
                    c.district +
                    '</span><br>★ ' +
                    c.rating +
                    '</div>'
                })
                marker.addListener('click', () => info.open(map, marker))
              })

              el.node._map = map
            }

            if (window.google && window.google.maps) {
              initMap()
            } else {
              window.initClinicMap = initMap
              const script = document.createElement('script')
              script.src =
                'https://maps.googleapis.com/maps/api/js?key=AIzaSyAIjI_gvh-OUSEdzgfHKh2v1GvwiEp2Ztg&callback=initClinicMap'
              script.async = true
              script.defer = true
              document.head.appendChild(script)
            }
          }
        },

        ShareLocationBtn: {
          tag: 'button',
          flow: 'x',
          align: 'center center',
          gap: 'Y',
          padding: 'Z A',
          round: 'Z',
          background: '#0D1117',
          color: '#FFFFFF',
          border: 'none',
          fontSize: 'Z',
          fontWeight: '600',
          cursor: 'pointer',
          width: '100%',
          transition: 'all 0.2s ease',
          ':hover': { opacity: '0.9' },
          onClick: (e, el, s) => {
            if (navigator.geolocation) {
              navigator.geolocation.getCurrentPosition(
                (pos) => {
                  s.root.update({
                    userLat: pos.coords.latitude,
                    userLng: pos.coords.longitude,
                    locationShared: true
                  })
                },
                () => {
                  alert(
                    'Location access denied. Please enable location services.'
                  )
                }
              )
            }
          },
          LocIcon: {
            extends: 'Icon',
            icon: 'mapPin',
            width: 'A',
            height: 'A',
            color: '#FFFFFF'
          },
          LocText: {
            text: (el, s) =>
              s.root.locationShared
                ? '{{ locationShared | polyglot }}'
                : '{{ shareLocation | polyglot }}'
          }
        }
      }
    }
  },

  StatsBar: {
    tag: 'section',
    flow: 'x',
    align: 'center center',
    gap: 'C',
    padding: 'D B',
    width: '100%',
    maxWidth: 'K',
    margin: '0 auto',
    flexWrap: 'wrap',
    '@mobileL': {
      display: 'grid',
      gridTemplateColumns: 'repeat(2, 1fr)',
      gap: 'B',
      padding: 'C A'
    },
    Stat1: {
      flow: 'y',
      align: 'center center',
      gap: 'Y',
      StatNum: {
        text: '150+',
        fontSize: 'D',
        fontWeight: '800',
        color: '#0D1117',
        letterSpacing: '-0.02em'
      },
      StatLabel: {
        text: '{{ statClinics | polyglot }}',
        fontSize: 'Y',
        color: 'inkMuted',
        textTransform: 'uppercase',
        letterSpacing: '0.1em',
        fontWeight: '500'
      }
    },
    StatDiv1: {
      width: '1px',
      background: 'rgba(0,0,0,0.1)',
      height: 'B',
      '@mobileL': { display: 'none' }
    },
    Stat2: {
      flow: 'y',
      align: 'center center',
      gap: 'Y',
      StatNum: {
        text: '65%',
        fontSize: 'D',
        fontWeight: '800',
        color: '#0D1117',
        letterSpacing: '-0.02em'
      },
      StatLabel: {
        text: '{{ statNoShows | polyglot }}',
        fontSize: 'Y',
        color: 'inkMuted',
        textTransform: 'uppercase',
        letterSpacing: '0.1em',
        fontWeight: '500'
      }
    },
    StatDiv2: {
      width: '1px',
      background: 'rgba(0,0,0,0.1)',
      height: 'B',
      '@mobileL': { display: 'none' }
    },
    Stat3: {
      flow: 'y',
      align: 'center center',
      gap: 'Y',
      StatNum: {
        text: '24/7',
        fontSize: 'D',
        fontWeight: '800',
        color: '#0D1117',
        letterSpacing: '-0.02em'
      },
      StatLabel: {
        text: '{{ statBooking | polyglot }}',
        fontSize: 'Y',
        color: 'inkMuted',
        textTransform: 'uppercase',
        letterSpacing: '0.1em',
        fontWeight: '500'
      }
    },
    StatDiv3: {
      width: '1px',
      background: 'rgba(0,0,0,0.1)',
      height: 'B',
      '@mobileL': { display: 'none' }
    },
    Stat4: {
      flow: 'y',
      align: 'center center',
      gap: 'Y',
      StatNum: {
        text: '500+',
        fontSize: 'D',
        fontWeight: '800',
        color: '#0D1117',
        letterSpacing: '-0.02em'
      },
      StatLabel: {
        text: '{{ statDentists | polyglot }}',
        fontSize: 'Y',
        color: 'inkMuted',
        textTransform: 'uppercase',
        letterSpacing: '0.1em',
        fontWeight: '500'
      }
    },
    StatDiv4: {
      width: '1px',
      background: 'rgba(0,0,0,0.1)',
      height: 'B',
      '@mobileL': { display: 'none' }
    },
    Stat5: {
      flow: 'y',
      align: 'center center',
      gap: 'Y',
      StatNum: {
        text: '4.8',
        fontSize: 'D',
        fontWeight: '800',
        color: '#0D1117',
        letterSpacing: '-0.02em'
      },
      StatLabel: {
        text: '{{ statRating | polyglot }}',
        fontSize: 'Y',
        color: 'inkMuted',
        textTransform: 'uppercase',
        letterSpacing: '0.1em',
        fontWeight: '500'
      }
    },
    StatDiv5: {
      width: '1px',
      background: 'rgba(0,0,0,0.1)',
      height: 'B',
      '@mobileL': { display: 'none' }
    },
    Stat6: {
      flow: 'y',
      align: 'center center',
      gap: 'Y',
      StatNum: {
        text: '12K+',
        fontSize: 'D',
        fontWeight: '800',
        color: '#0D1117',
        letterSpacing: '-0.02em'
      },
      StatLabel: {
        text: '{{ statPatients | polyglot }}',
        fontSize: 'Y',
        color: 'inkMuted',
        textTransform: 'uppercase',
        letterSpacing: '0.1em',
        fontWeight: '500'
      }
    }
  },

  ClaimBanner: {
    tag: 'section',
    flow: 'y',
    align: 'center center',
    gap: 'Z',
    padding: 'C B',
    width: '100%',
    maxWidth: 'K',
    margin: '0 auto',
    '@mobileL': { padding: 'B A' },

    BannerBox: {
      extends: 'Link',
      href: '/business',
      textDecoration: 'none',
      flow: 'y',
      align: 'flex-start flex-start',
      gap: 'Z',
      padding: 'B C',
      round: 'B',
      background: '#0D1117',
      width: '100%',
      position: 'relative',
      cursor: 'pointer',
      transition: 'all 0.2s ease',
      ':hover': { opacity: '0.95' },
      '@mobileL': { padding: 'B A' },

      BannerTitle: {
        tag: 'h3',
        text: '{{ ownClinic | polyglot }}',
        fontSize: 'E',
        fontWeight: '700',
        color: '#FFFFFF',
        letterSpacing: '-0.03em'
      },
      BannerText: {
        text: '{{ claimText | polyglot }}',
        fontSize: 'A',
        fontWeight: '400',
        color: '#FFFFFF',
        lineHeight: '1.6',
        maxWidth: 'I'
      },
      BannerBtn: {
        extends: 'Link',
        href: '/business',
        text: '{{ enterSpaceForClinics | polyglot }}',
        background: 'transparent',
        color: '#FFFFFF',
        fontWeight: '600',
        padding: '0',
        fontSize: 'A',
        textDecoration: 'none',
        cursor: 'pointer',
        position: 'absolute',
        bottom: 'C',
        right: 'C',
        transition: 'all 0.2s ease',
        ':hover': { color: '#FFFFFF' }
      }
    }
  },

  FooterSection: {
    tag: 'footer',
    flow: 'y',
    gap: 'Z',
    padding: 'B B',
    width: '100%',
    borderTop: '1px solid inkBorder',
    align: 'center center',
    FooterTop: {
      flow: 'x',
      align: 'center space-between',
      width: '100%',
      maxWidth: 'K',
      '@mobileL': { flow: 'y', gap: 'A', align: 'center center' },
      FooterLogo: {
        text: 'MCAI',
        fontSize: 'A',
        fontWeight: '700',
        color: 'inkText'
      },
      FooterLinks: {
        flow: 'x',
        gap: 'B',
        FeatLink: {
          extends: 'Link',
          text: '{{ features2 | polyglot }}',
          href: '/#features',
          color: 'inkMuted',
          fontSize: 'Z',
          textDecoration: 'none',
          fontWeight: '500',
          ':hover': { color: 'inkText' },
          transition: 'color 0.2s ease'
        },
        PriceLink: {
          extends: 'Link',
          text: '{{ pricing2 | polyglot }}',
          href: '/#pricing',
          color: 'inkMuted',
          fontSize: 'Z',
          textDecoration: 'none',
          fontWeight: '500',
          ':hover': { color: 'inkText' },
          transition: 'color 0.2s ease'
        },
        BookLink: {
          extends: 'Link',
          text: '{{ book | polyglot }}',
          href: '/booking',
          color: 'inkMuted',
          fontSize: 'Z',
          textDecoration: 'none',
          fontWeight: '500',
          ':hover': { color: 'inkText' },
          transition: 'color 0.2s ease'
        },
        DashLink: {
          extends: 'Link',
          text: '{{ dashboard2 | polyglot }}',
          href: '/dashboard',
          color: 'inkMuted',
          fontSize: 'Z',
          textDecoration: 'none',
          fontWeight: '500',
          ':hover': { color: 'inkText' },
          transition: 'color 0.2s ease'
        }
      },
      FooterContact: {
        text: 'hello@MCAI.ge',
        fontSize: 'Z',
        color: 'inkMuted'
      }
    },
    FooterCopy: {
      text: '{{ u00a92026Mcai | polyglot }}',
      fontSize: 'Y',
      color: 'inkMuted',
      marginTop: 'Z'
    }
  }
}
